import axios from 'axios';
import { API } from '../constants/api';
import UrlParser from '../utils/url-parser';

export const client = axios.create({
  baseURL: API.API_URL,
  headers: {
    'content-type': 'application/json',
    'TenantId': UrlParser.getTenantId(),
  },
});
